define('components/factory/enum/EnumViewType', [
], function(){

    return {
        MULTIMEDIAS_VIEW: "multimediasview",
        MULTIPRODUCTS_VIEW: "multiproductsview",
        PRODUCT_VIEW: "productview",
        SHARE_VIEW: "shareview",
        VIDEO_VIEW: "videoview",
        VIDEOPRODUCT_VIEW: "videoproductview",
        VIEWER_VIEW: "viewerview",
        MULTIITEMS_VIEW: "multiitemsview"
    };

});
